<template>
  <div class="modal right fade" :id="objectModalName.vtverarbeiter" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.vtverarbeiter)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.vtverarbeiter)">×</button>
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div class="company_img">
                <img src="@/assets/img/c-logo.png" alt="User" class="img-fluid" />
              </div>
              <div>
                <p class="mb-0">VT (Selbst Datenverarbeiter)</p>
                <span class="modal-title">{{currentVTSelbst.name}}</span>
                <a href="#" @click.prevent="setEdit(!edit)"><span class="lock"><i class="fa fa-pencil" aria-hidden="true" v-show="!edit"></i><i class="fa fa-lock" aria-hidden="true" v-show="edit"></i></span></a>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <p class="mt-2 mb-1 text-muted">Name<span class="text-danger">*</span></p>
                  <h4 class="mt-0" v-if="currentVTSelbst.id && !edit">{{currentVTSelbst.name}}</h4>
                  <input class="form-control" v-if="!currentVTSelbst.id || edit" v-model="currentVTSelbst.name" placeholder="Name" autocomplete="off">
                  <span class="error-message text-danger" v-show="v$.currentVTSelbst.name.$errors.length>0">{{ $t('required_field') }}</span>

                  <div class="row mt-2">
                    <div class="col-12">
                      <!-- start due date -->
                      <p class="mt-2 mb-1 text-muted">Kurzbeschreibung der Tätigkeit<span class="text-danger">*</span></p>
                      <div class="d-flex">
                        <i class='uil uil-schedule text-success me-1'></i>
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentVTSelbst.id && !edit">{{currentVTSelbst.description}}</h5>
                          <textarea class="form-control" v-if="!currentVTSelbst.id || edit" v-model="currentVTSelbst.description" autocomplete="off"></textarea>
                          <span class="error-message text-danger" v-show="v$.currentVTSelbst.description.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <!-- end due date -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <div class="row mt-2">
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Auftraggeber<span class="text-danger">*</span></p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentVTSelbst.id && !edit">{{currentVTSelbst.controller}}</h5>
                          <input class="form-control" v-if="!currentVTSelbst.id || edit" v-model="currentVTSelbst.controller" placeholder="Auftraggeber" autocomplete="off" />
                          <span class="error-message text-danger" v-show="v$.currentVTSelbst.controller.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Beschreibung der TOMs</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentVTSelbst.id && !edit">{{currentVTSelbst.toms}}</h5>
                          <input class="form-control" v-if="!currentVTSelbst.id || edit" v-model="currentVTSelbst.toms" placeholder="Beschreibung der TOMs" autocomplete="off" />
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <div class="row mt-2">
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt- mb-1 text-muted">Rechtsgrundlage der Datenverarbeitung</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentVTSelbst.id && !edit">{{currentVTSelbst.legal_base}}</h5>
                          <textarea class="form-control" v-if="!currentVTSelbst.id || edit" v-model="currentVTSelbst.legal_base" placeholder="Rechtsgrundlage der Datenverarbeitung" autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                    <div class="col-6">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Name des Prozesses/Verarbeitungstätigkeit</p>
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <h5 class="mt-1 fs-14" v-if="currentVTSelbst.id && !edit">{{currentVTSelbst.process_name}}</h5>
                          <textarea class="form-control" v-if="!currentVTSelbst.id || edit" v-model="currentVTSelbst.process_name" placeholder="Name des Prozesses/Verarbeitungstätigkeit" autocomplete="off"></textarea>
                        </div>
                      </div>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                  </div> <!-- end row -->

                  <!-- start attachments -->
                  <slot name="fileUpload"></slot>
                  <!-- end attachments -->
                  <!-- comments -->
                  <slot name="comments"></slot>
                  <!-- end comments -->
                </div> <!-- end col -->
              </div> <!-- end row-->
            </div> <!-- end card-body -->
          </div>
        </div>
        <div class="modal-footer" v-if="!currentVTSelbst.id || edit">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="saveVTSelbst" :key="btnEnableKey" :disabled="btnDisabled">Speichern</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.vtverarbeiter)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {service} from '@/utils/request.js';
import {ajaxErrorMessage, closeWarning, initSelect2} from '@/utils/index.js';
import { objectModalName } from '@/utils/enums.js';
import {mapState, mapMutations} from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  name: "VTSelbstComponent",
  props: {
    currentVTSelbst: {
      type: Object,
      required: true,
    },
    vtselbstNameList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      objectModalName: objectModalName,
      btnEnableKey: 1,
      btnDisabled: false,
    }
  },
  mounted() {
    initSelect2()
    $('#'+objectModalName.vtverarbeiter).on('hidden.bs.modal', () => {
      this.setEdit(false)
    })
  },
  beforeDestroy() {
    $('#'+objectModalName.vtverarbeiter).off('hidden.bs.modal')
  },
  computed: {
    ...mapState({
      accountid: state => state.account.accountid,
      userName: state => state.user.username,
      account: state => state.account,
      userID: state => state.user.id,
      edit: state => state.app.edit,
      departments: state => state.account.departments,
      suppliers: state => state.account.suppliers,
      modalDirty: state => state.app.modalDirty,
    }),
  },
  validations() {
    return {
      currentVTSelbst: {
        name: {required, $lazy: true},
        controller: {required, $lazy: true},
        description: {required, $lazy: true},
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    currentVTSelbst: {
      handler: function (newValue, oldVal) {
        if (!this.modalDirty) this.setModalDirty(true)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
    closeWarning,
    async saveVTSelbst() {
      if (this.currentVTSelbst.customer === '') this.currentVTSelbst.customer = this.account.name
      if (!this.currentVTSelbst.modified_by) this.currentVTSelbst.modified_by = this.userName
      const isValid = await this.v$.currentVTSelbst.$validate()
      if (!isValid) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      if (!this.currentVTSelbst.id && this.vtselbstNameList.some(item => item.name === this.currentVTSelbst.name)) {
        this.$vToastify.error('VTVerarbeiter mit gleichen Name existiert bereits!')
        return
      }
      this.btnDisabled = true
      let url = 'todos/v1/create_vtselbst/'
      let newVTSelbst = true
      if (this.currentVTSelbst.id) {
        url = `todos/v1/update_vtselbst/${this.currentVTSelbst.id}/`
        newVTSelbst = false
      }
      service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.currentVTSelbst
      }).then((response) => {
        this.setModalDirty(false)
        this.v$.$reset()
        this.btnDisabled = false
        this.$emit('vtselbstUpdated', response.data)
        $('#' + this.objectModalName.vtverarbeiter).modal('hide')
        this.$vToastify.success('VTSelbstVerarbeiter ist erfolgreich gespeichert!')
      }).catch(error => {
        this.btnDisabled = false
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    },
  }
}
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}

</style>
